import React from 'react';

class ErrorBoundary extends React.Component {
        constructor(props) {
                super(props);
                this.state = { hasError: false, error: null };
        }

        static getDerivedStateFromError(error) {
                return { hasError: true, error };
        }

        componentDidCatch(error, errorInfo) {
                console.error('Error caught by boundary:', error, errorInfo);
        }

        render() {
                if (this.state.hasError) {
                        return (
                                <div className="min-h-screen flex items-center justify-center bg-red-50">
                                        <div className="max-w-md p-8 bg-white rounded-lg shadow-lg text-center">
                                                <h2 className="text-2xl font-bold text-red-600 mb-4">
                                                        Something went wrong
                                                </h2>
                                                <p className="text-gray-600 mb-6">
                                                        {this.state.error?.message || 'An unexpected error occurred'}
                                                </p>
                                                <button
                                                        onClick={() => window.location.href = '/'}
                                                        className="px-4 py-2 bg-brand text-white rounded hover:bg-brand/90"
                                                >
                                                        Return Home
                                                </button>
                                        </div>
                                </div>
                        );
                }

                return this.props.children;
        }
}

export default ErrorBoundary;
